import React from "react";
import "./css/home.css";
import { Link, Redirect } from "react-router-dom";

class Home extends React.Component {
  constructor(props) {
    super(props);
  }

  // componentDidMount() {
  //   setTimeout(function () {
  //     window.location.href = "/tracker";
  //   }, 5000);
  // }

  render() {
    return (
      <section className="homeScreen">
        <div className="container homeContainer">
          <div className="row">
            <div className="col-12 headerColumn">
              <h3>Global</h3>
              <h2>COVID19 Data</h2>
              <h3>Tracker</h3>
            </div>
            <div className="col-12 text-center">
              <Link to="/tracker" className="btn-enter">
                Enter Now
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Home;
